module.exports = __webpack_public_path__ + "img/portfolio.20d41bd4.svg";